import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import { useEquiposMutations } from '../../hooks'
import { ButtonSubmit, FooterPages } from '..';
import { getMaquinas } from '../../services/Maquinas';

const initialState = {
empresa:'',
codigo: '',
nombreEquipo: '',
marca: '',
modelo: '',
anno: '',
horometro: '',
serie:'',
patente:'',
Kilometraje: '',
capacidad: '',
tipo: '',
descripcion: '',
estado: 'Activo',
};

const NuevoEquipo = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const { addEquipo, updateEquipoC } = useEquiposMutations();
  const [equipoData, setEquipoData] = useState([]);
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  useEffect(() => {
    if(vecinoData) setFormData(vecinoData);
  }, [vecinoData]);

  useEffect(() => {
    const fetchData = async () => {
      const misEquipos = await getMaquinas();
      setEquipoData(misEquipos);

    };
    fetchData();
  },[]);


  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) =>{
    e.preventDefault();

    // Validaciones

    if(!vecinoData._id) 
    {
      // console.log('crear VECINO');
       await addEquipo.mutateAsync( formData );
    } else
    { 
       await updateEquipoC.mutateAsync( formData );
    };
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevoequipo );

  }
  
  return (
    <form  onSubmit={handleSubmit} >
    <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-2/3 p-8">
          
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                {!vecinoData ? "Nueva" : "Editar"} Equipo
              </p>
            </div>

            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.nuevoequipo)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>
          
          <div className="mt-5 space-y-4">
          <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
            <div className="col-span-2">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Equipo*</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="codigo"
                      value= {formData.codigo}
                      required
                      onChange={handleChange}
                    />
                </div>
                </div>
                {/*
                <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-sm font-semibold mb-1">Nombre</label>
                    <input
                        className="text-xs border border-gray-300 p-2 rounded"
                        type="text"
                        placeholder=""
                        name="nombreEquipo"
                        value= {formData.nombreEquipo}
                        required
                        onChange={handleChange}
                      />
                  </div>
                </div> */}
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Maquina*</label>
                  <select className={inputClass} name="tipo"
                          value={formData.tipo} onChange={handleChange}>
                        <option value=""></option>
                        {equipoData?.map((item, index) => (
                          <option  key={item._id} value={item._id}>{item.nombreMaquina}</option>
                        ))}  
                        </select>
                </div>

              </div>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Marca</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="marca"
                      value= {formData.marca}
                      required
                      onChange={handleChange}
                    />
                </div>
                <div className="col-span-2">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Modelo</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="modelo"
                      value= {formData.modelo}
                      required
                      onChange={handleChange}
                    />
                </div>
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Año*</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="anno"
                      value= {formData.anno}
                      required
                      onChange={handleChange}
                    />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" >
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Kilometraje</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="kilometraje"
                      value= {formData.kilometraje}
                      required
                      onChange={handleChange}
                    />
                </div>

                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Capacidad</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="capacidad"
                        value= {formData.capacidad}
                        required
                        onChange={handleChange}
                      />
                  </div>

                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Horometro</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="horometro"
                        value= {formData.horometro}
                        required
                        onChange={handleChange}
                      />
                  </div>

              </div>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Serie</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="serie"
                        value= {formData.serie}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Patente</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="patente"
                        value= {formData.patente}
                        required
                        onChange={handleChange}
                    />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >

                <div className="col-span-3">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Descripción</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="descripcion"
                        value= {formData.descripcion}
                        required
                        onChange={handleChange}
                      />
                  </div>
                </div>
                <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Estado*</label>
                      <select className={inputClass} name="estado" value= {formData.estado} required onChange={handleChange}>
                        <option value="ACTIVO">Activo</option>
                        <option value="Asignado">Asignado</option>
                        <option value="INACTIVO">Inactivo</option>
                        <option value="ELIMINADO">Eliminado</option>
                      </select>
                  </div>

              </div>

              </div>

              <div className="grid grid-cols-1 gap-4" >
                  <div className="flex flex-col">
                      <ButtonSubmit
                        color="white"
                        bgColor={currentColor}
                        text= { !vecinoData ? "Crear Nuevo": "Guardar Cambios"}  
                        borderRadius="10px"
                        onClick = {handleSubmit}
                        width="full"
                      />   
                  </div>
              </div>           
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevoEquipo;